// @flow
import red from '@mui/material/colors/red';

const CONTENT_WIDTH = 700;
const WIDTH_WITH_MARGINS = CONTENT_WIDTH + 8 * 4;

const memberContentStyles = {
  container: (theme) => ({
    flexGrow: 1,
    width: '100%',
    padding: theme.spacing(3), // Desktop padding: 24px all around
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 0,
      padding: `0 ${theme.spacing(1.5)}`,  // 12px horizontal padding on mobile
      margin: 0,   // Ensure no margin on mobile
      maxWidth: '100%',  // Use parent width instead of viewport
      boxSizing: 'border-box'  // Include padding in width calculation
      // paddingTop is handled by ContentContainer wrapper
    }
  }),

  debug: (theme) => ({
    ...theme.layout.debug.member
  }),

  margin: (theme) => ({
    margin: theme.spacing(1)
  }),

  toolbar: (theme) => ({
    ...theme.layout.customProps.toolbar
  }),

  icon: () => ({
    fontSize: '1rem'
  }),

  iconSpinner: () => ({
    width: '100%',
    padding: 10,
    display: 'block'
  }),

  welcomeMessage: (theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: theme.spacing(2),
    '& > *': {
      paddingLeft: theme.spacing(1),
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(2),
      fontSize: '1rem'
    }
  }),

  paginateFooter: (theme) => ({
    marginTop: theme.spacing(1),
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: `0px ${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)}`
    }
  }),

  pageNumber: () => ({
    textAlign: 'center',
    flex: '1 1 auto'
  }),

  pageNext: () => ({
    textAlign: 'right'
  }),

  pagePrev: () => ({
    textAlign: 'left'
  }),

  fab: (theme) => ({
    margin: theme.spacing(0.5)
  }),

  assigneeChip: (theme) => ({
    backgroundColor: theme.palette.primary.main,
    fontWeight: 'bold'
  }),

  mobileAssigneeChip: (theme) => ({
    marginLeft: theme.spacing(1)
  }),

  taskNameTooltip: (theme) => ({
    padding: theme.spacing(1.5),
    fontSize: '0.9rem',
    maxWidth: 500
  }),

  inlineRowTextReadonly: () => ({
    marginTop: 6
  }),

  phoneNb: (theme) => ({
    fontWeight: 800,
    color: '#5b5b5b',
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  }),

  phoneNbMobile: (theme) => ({
    marginTop: theme.spacing(1),
    fontWeight: 800,
    color: '#5b5b5b',
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem'
    }
  }),

  filterButton: (theme) => ({
    display: 'flex',
    alignItems: 'center'
  }),

  filterArea: () => ({
    backgroundColor: 'blue'
  }),

  pageInfoCtr: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1)
    }
  }),

  persistentFilterBar: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: 0,
    minHeight: theme.spacing(5), // Ensure consistent height even when empty
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  }),

  noResultsCtr: () => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: '400px' // Ensure enough height for centered content
  }),

  noResultsMessageCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    color: theme.palette.custom.backgroundTextInfo,
    textAlign: 'center'
  }),

  infoText: (theme) => ({
    color: theme.palette.custom.backgroundTextInfo,
    position: 'absolute',
    right: '45%',
    top: '30%',
    textAlign: 'center'
  }),

  searchIcon: () => ({
    fontSize: 70
  }),

  pageInfoCtrNoResults: (theme) => ({
    // position: 'absolute',
    right: 0,
    marginBottom: theme.spacing(1),
    display: 'flex'
  }),

  messageHeader: () => ({
    fontWeight: 700
  }),

  messagePreview: () => ({
    fontWeight: 500
  }),

  blockquoteCtr: (theme) => ({
    ...theme.layout.customProps.blockquote(WIDTH_WITH_MARGINS),
    marginTop: theme.spacing(3),
    fontStyle: 'normal',
    // Mobile-first approach - ensure no horizontal overflow
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,  // Allow shrinking below content size
    padding: theme.spacing(2),
    fontSize: '1rem',
    backgroundColor: theme.palette.custom.neoYellow.main,
    borderRadius: theme.spacing(2),
    boxSizing: 'border-box',
    overflowX: 'hidden',  // Prevent horizontal scrolling
    [theme.breakpoints.down('sm')]: {
      // Container-relative approach - respect parent boundaries
      margin: `${theme.spacing(3)} 0 0 0`,  // Remove horizontal margins
      width: '100%',     // Use full parent width
      maxWidth: '100%',   // Respect parent container bounds
      fontSize: '0.9rem',
      lineHeight: '1.5',
    },
    [theme.breakpoints.up('sm')]: {
      // Desktop styling
      ...theme.layout.customProps.blockquote(WIDTH_WITH_MARGINS),
      fontStyle: 'normal',  // Override italic from blockquote spread
      paddingTop: theme.spacing(3),  // 24px instead of 8px from blockquote spread
      paddingBottom: theme.spacing(3),
      margin: `${theme.spacing(3)} 0 0 0`,
      overflowX: 'visible'
    },
    // Ensure text content wraps properly on mobile
    '& blockquote': {
      margin: 0,
      padding: 0,
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        marginInlineStart: theme.spacing(1),
        marginInlineEnd: theme.spacing(1)
      },
      [theme.breakpoints.up('sm')]: {
        marginInlineStart: theme.spacing(4),
        marginInlineEnd: theme.spacing(4)
      }
    },
    // Ensure all text content wraps aggressively
    '& p, & h1, & h2, & h3, & h4, & h5, & h6': {
      wordWrap: 'break-word',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      maxWidth: '100%',
      minWidth: 0,
      margin: `${theme.spacing(1)} 0`,
      boxSizing: 'border-box'
    },
    // Ensure links break properly
    '& a': {
      wordWrap: 'break-word',
      overflowWrap: 'anywhere',
      wordBreak: 'break-all',
      maxWidth: '100%',
      minWidth: 0,
      display: 'inline-block',
      boxSizing: 'border-box'
    },
    // Ensure phone numbers and long text strings break
    '& *': {
      maxWidth: '100%',
      minWidth: 0,
      boxSizing: 'border-box'
    }
  }),

  errorCtr: (theme) => ({
    marginBottom: theme.spacing(1)
  }),

  certificationBannerCtr: (theme) => ({
    marginBottom: theme.spacing(1)
  }),

  certificationBannerWelcome: (theme) => ({
    width: '100%',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      maxWidth: WIDTH_WITH_MARGINS
    }
  }),

  certificationBannerFeed: (theme) => ({
    marginBottom: theme.spacing(1),
    width: '100%',
    maxWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100vw - ${theme.layout.customProps.drawer.width}px - ${theme.spacing(6)})`,
      maxWidth: '100%'
    }
  }),

  editIcon: (theme) => ({
    marginLeft: theme.spacing(0.5),
    fontSize: '1.25rem',
    marginTop: theme.spacing(0.4),
    color: '#bcbcbc'
  }),

  editTenantCtr: (theme) => ({
    position: 'relative',
    left: -theme.spacing(1),
    padding: `0px ${theme.spacing(1)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      '& svg': {
        color: `${theme.palette.primary.main} !important`
      },
      backgroundColor: 'hsl(0,0%,95%)',
      cursor: 'pointer'
    }
  }),

  editableName: () => ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    top: -2
  }),

  mobileIssueDesc: () => ({})
};

export default memberContentStyles;